import { h } from "@stencil/core";
import { JsonParser } from "../../utils";
import { getAceHeaderSubmenuNames } from "./ace-header-submenu.get-names";
export class AceHeaderSubmenu {
    componentWillLoad() {
        var _a;
        this.names = getAceHeaderSubmenuNames((_a = this.hostElement) === null || _a === void 0 ? void 0 : _a.id);
        this.parseItems();
        this.parseSubmenuIcon();
    }
    parseItems() {
        this._items = new JsonParser(this.items, []).getValue();
    }
    parseSubmenuIcon() {
        this._submenuIcon = new JsonParser(this.submenuIcon, {}).getValue();
    }
    renderSubmenuIcon() {
        var _a, _b, _c, _d, _e, _f, _g;
        const isVertical = (_b = (_a = this._submenuIcon) === null || _a === void 0 ? void 0 : _a.name) === null || _b === void 0 ? void 0 : _b.startsWith('vertical-');
        const verticalName = (_d = (_c = this._submenuIcon) === null || _c === void 0 ? void 0 : _c.name) === null || _d === void 0 ? void 0 : _d.replace('vertical-', '');
        const Tag = ((_e = this._submenuIcon) === null || _e === void 0 ? void 0 : _e.href) ? 'a' : 'div';
        const iconAttributes = Object.assign(Object.assign(Object.assign({ class: this.names.CLASS.ICON }, (((_f = this._submenuIcon) === null || _f === void 0 ? void 0 : _f.href) && { href: this._submenuIcon.href })), (((_g = this._submenuIcon) === null || _g === void 0 ? void 0 : _g.target) && { target: this._submenuIcon.target })), (isVertical && {
            style: {
                '--ace-header-submenu-icon-bg-color': `var(--ace-color-brand-verticals--${verticalName})`,
            },
        }));
        return (h("div", { class: this.names.CLASS.ICON_WRAPPER }, h(Tag, Object.assign({}, iconAttributes), h("ace-icon", { name: this._submenuIcon.name, size: 's', color: isVertical ? 'text-neutral--interactive-uni-light' : 'text-neutral--interactive' }))));
    }
    render() {
        var _a;
        return (h("div", { key: 'e9cb161d2d0571e9b48a2625386cbde246017277', id: this.names.ID.ROOT, class: this.names.CLASS.ROOT }, ((_a = this._submenuIcon) === null || _a === void 0 ? void 0 : _a.name) && this.renderSubmenuIcon(), h("div", { key: '8e1b9291b83c354c1736aa50a7e9ed28127cd138', class: this.names.CLASS.TABS }, h("ace-tabs", { key: '4f3718897041c30131107cbffa725317b80422c5', items: this._items, "with-left-padding": 'false' }))));
    }
    static get is() { return "ace-header-submenu"; }
    static get encapsulation() { return "shadow"; }
    static get originalStyleUrls() {
        return {
            "$": ["./ace-header-submenu.scss"]
        };
    }
    static get styleUrls() {
        return {
            "$": ["ace-header-submenu.css"]
        };
    }
    static get properties() {
        return {
            "items": {
                "type": "string",
                "mutable": false,
                "complexType": {
                    "original": "IAceTabsItem[] | string",
                    "resolved": "IAceTabsItem[] | string",
                    "references": {
                        "IAceTabsItem": {
                            "location": "import",
                            "path": "../ace-tabs/ace-tabs.types",
                            "id": "src/components/ace-tabs/ace-tabs.types.ts::IAceTabsItem"
                        }
                    }
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": ""
                },
                "getter": false,
                "setter": false,
                "attribute": "items",
                "reflect": false
            },
            "submenuIcon": {
                "type": "string",
                "mutable": false,
                "complexType": {
                    "original": "IAceHeaderSubmenuIcon | string",
                    "resolved": "string | { name: string; href: string; target?: string; }",
                    "references": {
                        "IAceHeaderSubmenuIcon": {
                            "location": "import",
                            "path": "./ace-header-submenu.types",
                            "id": "src/components/ace-header-submenu/ace-header-submenu.types.ts::IAceHeaderSubmenuIcon"
                        }
                    }
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": ""
                },
                "getter": false,
                "setter": false,
                "attribute": "submenu-icon",
                "reflect": false
            }
        };
    }
    static get elementRef() { return "hostElement"; }
    static get watchers() {
        return [{
                "propName": "items",
                "methodName": "parseItems"
            }, {
                "propName": "submenu-icon",
                "methodName": "parseSubmenuIcon"
            }];
    }
}
//# sourceMappingURL=ace-header-submenu.js.map
